{
  "common": {
    "show": "Show",
    "about": "About",
    "newPost": "New Post",
    "active": "Active",
    "change": "Change",
    "remove": "Remove",
    "cancel": "Cancel",
    "publish": "Publish",
    "save": "Save",
    "draft": "Draft",
    "scheduled": "Scheduled",
    "published": "Published",
    "actions": "Actions",
    "archive": "Archive",
    "delete": "Delete",
    "edit": "Edit",
    "edited": "Edited",
    "settings": "Settings",
    "signUp": "Sign Up",
    "by": "By",
    "for": "for",
    "you": "You",
    "one": "one",
    "option": "Option ",
    "registered": "Registered",
    "to": "to",
    "allEvents": "All events",
    "placeholder": "placeholder",
    "percentOf": "% of",
    "private": "Private",
    "updatedOn": "Updated on",
    "blogPost": "Blog Post",
    "category": "Category",
    "author": "Author",
    "status": "Status",
    "errors": {
      "label": "Errors",
      "SOMETHING_WENT_WRONG": "Something went wrong. Please try again later."
    },
    "all": "All",
    "archived": " Archived",
    "back": "Back",
    "restore": "Restore this version",
    "next": "Next",
    "previous": "Previous",
    "continue": "Continue",
    "continueButton": "Continue",
    "paid": "Paid",
    "free": "Free",
    "uploadImagesVideos": "Upload Images / Videos",
    "upload": "Upload",
    "add": "Add",
    "on": "On",
    "from": "from",
    "members": "members",
    "visibility": "Visibility",
    "public": "Public",
    "description": "Description",
    "managedBy": "Managed By",
    "noManagers": "No Managers",
    "noDescription": "No Description",
    "more": "more",
    "moreCaps": "More",
    "less": "less",
    "and": "and",
    "in": "in",
    "allSet": "You are all set!",
    "createdBy": "Created By",
    "home": "Home",
    "selected": "Selected",
    "groupMembers": "Group Members",
    "everyone": "Everyone",
    "manager": "Manager",
    "leave": "Leave",
    "membersList": "Members List",
    "findChannelManagers": "Find Channel Managers",
    "searchGroupMembers": "Search Group Members",
    "searchMembers": "Search Members",
    "searchMember": "Search Member",
    "enterDescription": "Enter Description",
    "apply": "Apply",
    "selectRole": "Select Role",
    "people": "People",
    "viewProfile": "View Profile",
    "leaderboard": "Leaderboard",
    "events": "Events",
    "logOut": "Log Out",
    "topLevelReached": "Top level reached",
    "topLevelReachedExclaim": "Top level reached!",
    "congratsTopLevel": "Congrats! You've reached the top level!",
    "share": "Share",
    "copyLink": "Copy Link",
    "reply": "Reply",
    "download": "Download",
    "noPreviewAvailable": "No Preview Available",
    "userNotFound": "User not found",
    "userNotFoundMessage": "User not found",
    "thisGroupIsPrivate": "This group is private",
    "unableToPreviewPdf": "Currently, unable to preview the PDF file. Please download it to view.",
    "failedToDownloadPdf": "Failed to download the PDF file",
    "notifyAll": "Notify all in the channel",
    "communities": "Communities",
    "courses": "Courses",
    "affiliates": "Affiliates",
    "chats": "Chat",
    "switchToDarkMode": "Switch to dark mode",
    "switchToLightMode": "Switch to light mode",
    "editProfile": "Edit Profile",
    "account": "Account",
    "logout": "Logout",
    "noResults": "No results",
    "confirmPayment": "Confirm Payment",
    "done": "Done",
    "manage": "MANAGE",
    "copied": "Copied",
    "submit": "Submit",
    "request": "Request",
    "approve": "Approve",
    "decline": "Decline",
    "comingSoon": "Coming Soon",
    "detailsUpdatedSuccessfully": "Details Updated Successfully",
    "oopsUnableToSaveDetails": "Oops! Unable to save details.",
    "verificationFailedPleaseTryAgain": "Verification failed! Please try again",
    "loading": "Loading",
    "title": "Title",
    "addLink": "Add Link",
    "writeHere": "Write here",
    "copy": "Copy",
    "reset": "Reset",
    "register": "Register",
    "search": "Search",
    "confirm": "Confirm",
    "success": "Success",
    "toReview": "To Review",
    "invite": "Invite",
    "contributions": "Contributions",
    "communitiesSettings": "Communities Settings",
    "create": "Create",
    "name": "Name",
    "linkCopied": "Link Copied!",
    "move": "Move",
    "irreversible": "irreversible",
    "close": "Close",
    "greeting": "Hi, {name}!",
    "managePayments": "Manage Payments",
    "manageYourAccount": "Manage Your Account",
    "accountSettings": "Account Settings",
    "proceed": "Proceed",
    "uploading": "Uploading",
    "retry": "Retry",
    "login": "Login",
    "follow": "Follow",
    "following": "Following",
    "followers": "Followers",
    "view": "VIEW",
    "selectAnOption": "Select an option",
    "channels": "Channels",
    "somethingWentWrong": "Something went wrong, Please try again",
    "switchToNormalMode": "Switch to normal mode",
    "switchToReadingMode": "Switch to reading mode",
    "goToHomepage": "Go to Homepage",
    "onlyGroupOwnersCanCreateCourses": "Only Group Owners Can Create New Courses",
    "createGroup": "Create Group",
    "discover": "Discover",
    "continuePayment": "Continue Payment",
    "invalidCredentials": "You have entered an invalid email or password. Please try again.",
    "comingUpEvents": "Coming up events!",
    "integratePaymentGateway": "Integrate Payment Gateway",
    "connectPaymentGateway": "Connect a new payment gateway or manage your existing ones.",
    "isLive": "is Live",
    "justNow": "Just Now",
    "likes": "Likes",
    "accessRequired": "Access*",
    "zeroProgress": "0",
    "noFollowersTitle": "Looks like No One Follows You.",
    "noFollowersSubtext": "Add your connection to follow list",
    "noFollowingTitle": "You are not following anyone yet.",
    "noFollowingSubtext": "Start following people to see their posts",
    "followBack": "Follow Back",
    "logIn": "LOG IN",
    "video": "Video",
    "audio": "Audio",
    "newVersionAvailable": "A new version of the app is available. Please update to use this feature!",
    "ariaLabels": {
      "backButton": "Back Button",
      "openEventLocation": "Open Event Location",
      "editEvent": "Edit Event",
      "deleteEvent": "Delete Event",
      "cancelRsvp": "Cancel RSVP",
      "publicGroupRadio": "Public Group Radio Button",
      "privateGroupRadio": "Private Group Radio Button",
      "accessibleFromSwitcherCheckbox": "Accessible from switcher checkbox",
      "allowMembersToInviteCheckbox": "Allow members to invite checkbox",
      "addMembers": "Add Members",
      "settings": "Settings",
      "leaveChannel": "Leave Channel",
      "channelSettings": "Channel Settings",
      "selectRole": "Select Role",
      "deleteChannel": "Delete Channel",
      "changeToPrivateChannel": "Change to Private Channel",
      "allowMembersToPosts": "Allow Members to Posts",
      "restrictMembersFromPosts": "Restrict Members from sending Posts",
      "close": "Close",
      "open": "Open",
      "more": "More",
      "upload": "Upload",
      "play": "Play",
      "pause": "Pause",
      "mute": "Mute",
      "unmute": "Unmute",
      "fullscreen": "Fullscreen",
      "exitFullscreen": "Exit Fullscreen",
      "download": "Download",
      "share": "Share",
      "like": "Like",
      "comment": "Comment",
      "reply": "Reply",
      "pin": "Pin",
      "unpin": "Unpin",
      "report": "Report",
      "copyLink": "Copy Link",
      "embedCode": "Embed Code",
      "previewImage": "Preview image",
      "profileImage": "Profile image",
      "coverImage": "Cover Image",
      "thumbnail": "Thumbnail",
      "attachment": "Attachment",
      "removeAttachment": "Remove attachment",
      "uploadFile": "Upload file",
      "selectFile": "Select file",
      "searchIcon": "Search icon",
      "menuIcon": "Menu icon",
      "notification": "Notification",
      "messages": "Messages",
      "profile": "Profile",
      "logout": "Logout",
      "send": "Send",
      "cancel": "Cancel",
      "submit": "Submit",
      "next": "Next",
      "previous": "Previous",
      "refresh": "Refresh",
      "filter": "Filter",
      "sort": "Sort",
      "view": "View",
      "expand": "Expand",
      "collapse": "Collapse",
      "downloadFile": "Download File",
      "closeModal": "Close Modal",
      "addMedia": "Add Media",
      "lightModeRadio": "Light Mode Radio Button",
      "darkModeRadio": "Dark Mode Radio Button",
      "communityThemeRadio": "Community Theme Radio Button",
      "userProfile": "User Profile",
      "postActions": "Post Actions",
      "chatWindow": "Chat Window",
      "chatActions": "Chat Actions",
      "minimizeChat": "Minimize Chat",
      "closeChat": "Close Chat",
      "commentActions": "Comment Actions",
      "replyToComment": "Reply to Comment",
      "groupLogo": "Group Logo",
      "pinGroupIcon": "Pin Group Icon",
      "appSwitcher": "App Switcher",
      "communities": "Communities",
      "courses": "Courses",
      "search": "Search",
      "giphyLogo": "Giphy logo",
      "backToConversations": "Back to Conversations",
      "commentAttachments": "Comment Attachments",
      "tabSwitcher": "Tab Switcher",
      "eventCover": "Event Cover",
      "eventCoverPreview": "Event Cover Preview",
      "selectPaidEvent": "Select Paid Event",
      "selectFreeEvent": "Select Free Event",
      "selectCurrency": "Select Currency",
      "logo": "Logo",
      "closeReviewMembershipAnswersModal": "Close Review Membership Answers Modal",
      "liveStream": "Live Stream",
      "openGroupMembers": "Open Group Members",
      "communityBanner": "Community Banner",
      "home": "Home",
      "mentionItem": "Mention Item",
      "back": "Back",
      "viewGroup": "View Group",
      "invitationIcon": "Invitation Icon",
      "openUserProfile": "Open User Profile",
      "closeStream": "Close stream",
      "groupAvatar": "Group avatar",
      "bannerImage": "Banner image",
      "avatarImage": "Avatar image",
      "userAvatar": "User Avatar",
      "eventImage": "Event image",
      "postImage": "Post image",
      "channelIcon": "Channel icon",
      "groupIcon": "Group icon",
      "communityIcon": "Community icon",
      "memberAvatar": "Member avatar",
      "creatorAvatar": "Creator avatar",
      "authorAvatar": "Author avatar",
      "aboutFeaturedPost": "About Featured Post",
      "accountSettings": "Account Settings",
      "addChannel": "Add Channel",
      "addCourse": "Add Course",
      "addEmoji": "Add Emoji",
      "affiliates": "Affiliates",
      "announceEvents": "Announce Events",
      "avatar": "Avatar",
      "badge": "Badge",
      "camera": "Camera",
      "cardImage": "Card Image",
      "categoryName": "Category Name",
      "channelList": "Channel List",
      "channelSelect": "Channel Select",
      "chatAttachment": "Chat Attachment",
      "chats": "Chats",
      "closeCourseDetails": "Close Course Details",
      "closeLoginModal": "Close Login Modal",
      "closeMembershipQuestionsModal": "Close Membership Questions Modal",
      "closePaymentModal": "Close Payment Modal",
      "commentCard": "Comment card",
      "communityTheme": "Community Theme",
      "conversationItem": "Conversation Item",
      "conversationSuggestion": "Conversation Suggestion",
      "createChannel": "Create Channel",
      "customThemeRadio": "Custom Theme Radio Button",
      "deleteAnswerButton": "Delete Answer Button",
      "deleteFile": "Delete File",
      "editLevelName": "Edit Level Name",
      "editProfile": "Edit Profile",
      "enterEmailAddress": "Enter Email Address",
      "featuredIcon": "Featured Icon",
      "giveAdministrativePrivileges": "Give Administrative Privileges",
      "gokollabLogo": "Gokollab Logo",
      "icon": "Icon",
      "image": "Image",
      "likeContent": "Like content",
      "link": "Link",
      "marketplaceGroupSlug": "Marketplace Group Slug",
      "microphone": "Microphone",
      "nextAttachment": "Next Attachment",
      "noEvents": "No Events",
      "noCommunitiesIllustration": "No communities illustration",
      "noCoursesFound": "No courses found",
      "noFollowers": "No followers",
      "noFollowing": "No following",
      "noPostsFound": "No posts found",
      "notificationItem": "Notification Item",
      "notificationsList": "Notifications List",
      "openEmbeds": "Open Embeds",
      "openEmbedsDrawer": "Open Embeds Drawer",
      "openEventColor": "Open Event Color",
      "openEventDetails": "Open Event Details",
      "permissionNeeded": "Permission needed",
      "pointsAndLevels": "Points & Levels",
      "previousAttachment": "Previous Attachment",
      "reactedUser": "Reacted User",
      "reward": "Reward",
      "rewards": "Rewards",
      "selectChannel": "Select Channel",
      "selectEventOption": "Select Event Option",
      "selectIcon": "Select Icon",
      "selectTimezone": "Select Timezone",
      "showChannelIcons": "Show Channel Icons",
      "sidebarActionButton": "Sidebar Action Button",
      "speaker": "Speaker",
      "text": "Text",
      "thisGroupIsPrivate": "This group is private",
      "toReview": "To Review",
      "toggleFeaturedPost": "Toggle Featured Post",
      "toggleRewardsOptions": "Toggle Rewards Options",
      "viewReplies": "View Replies",
      "courseThumbnail": "course-thumbnail",
      "moreManagers": "more managers",
      "arrowIcon": "→",
      "okHandEmoji": "👌",
      "closeIcon": "✕",
      "changeToPublicChannel": "Change to Public Channel",
      "showMandatoryInfoModal": "Show mandatory profile modal checkbox"
    },
    "placeholders": {
      "groupName": "Group Name",
      "groupSlug": "Group Slug",
      "url": "URL",
      "enterPrice": "Enter Price",
      "enterName": "Enter Name",
      "enterEmail": "Enter Email",
      "selectTimezone": "Select Timezone",
      "selectChannel": "Select Channel",
      "enterSkoolGroupUrl": "Enter your Skool's group URL"
    },
    "email": "Email",
    "errorLoadingConversations": "Error Loading Conversations",
    "noConversations": "No Conversations"
  },
  "imageUpload": {
    "cropYourAvatar": "Crop Your Avatar",
    "dragToReposition": "Drag to reposition",
    "ariaLabels": {
      "imageUploader": "Image Uploader",
      "avatar": "Avatar",
      "clearFile": "Clear File",
      "removeAvatar": "Remove profile avatar",
      "zoomButton": "Zoom button"
    }
  },
  "mediaUpload": {
    "uploadVideo": "Upload Video",
    "addVideoUsingLink": "Add Video Using Link",
    "uploadImage": "Upload Image",
    "addVideo": "Add Video"
  },
  "mandatedInfoModal": {
    "completeYourProfile": "Complete Your Profile",
    "profileIntentMessage1": "Communities feel weird without faces and names.",
    "profileIntentMessage2": "Profiles build trust and spark connection with others",
    "complete": "COMPLETE",
    "recommendedAspectRatio": "Upload a {types}. Recommended Aspect Ratio 1:1",
    "addBio": "Add a bio... (Optional)"
  },
  "validations": {
    "nameRequired": "Name is required!",
    "invalidDescription": "Invalid Description!"
  },
  "payment": {
    "recurringWithTrial": "You will be charged {currencySymbol}{price} per {interval} after trial period is over with the option to cancel at any time.",
    "recurring": "{currencySymbol}{price} per {interval} with the option to cancel at any time.",
    "oneTime": "{currencySymbol}{price} {paymentText}",
    "defaultOneTimeText": "one time price for membership.",
    "totalAmount": "Total Amount",
    "trialDays": "{days} Day Trial",
    "securePayments": "100% secure & safe payments",
    "allowToChargeCard": "By providing your card information, you allow {locationName} to charge card for future payments in accordance with their terms.",
    "paymentSuccessful": "Payment Successful!",
    "errors": {
      "FDS_DECLINED": "Your transaction has been declined. Please contact the business owner."
    }
  },
  "channel": {
    "notifications": {
      "managersEdited": "Managers Edited Successfully!",
      "managersAdded": "Managers Added Successfully!",
      "managersAddedToChannel": "managers added to",
      "membersAdded": "Members Added Successfully!",
      "memberPostingEnabled": {
        "title": "Successfully updated member posting",
        "content": "Member posting has been enabled"
      },
      "roleUpdated": "Role Updated Successfully!",
      "updatedRoleOf": "Updated role of {name}",
      "userRemoved": "Removed User Successfully!",
      "removedUserFrom": "Removed {name} from {channelName}",
      "errorOccurred": "An Error Occurred",
      "CHANNEL_MEMBER_ROLE_UPDATE_NOT_FOUND": "Unable to update role because this member could not be found.",
      "CHANNEL_MEMBER_ROLE_UPDATE_OWNER_FORBIDDEN": "This action is not allowed for the group owner.",
      "CHANNEL_MEMBER_REMOVE_USER_NOT_FOUND": "Unable to remove user because this member could not be found.",
      "CHANNEL_MEMBER_REMOVE_CHANNEL_NOT_FOUND": "Unable to remove user because this channel could not be found.",
      "CHANNEL_MEMBER_REMOVE_OWNER_FORBIDDEN": "The group owner cannot be removed from the channel.",
      "CHANNEL_MEMBER_REMOVE_USER_NOT_IN_CHANNEL": "This user is not part of the selected channel.",
      "updated": {
        "title": "Updated Channel Settings",
        "contentPrivate": "Channel {channelName} is now private",
        "contentPublic": "Channel {channelName} is now public",
        "content": ""
      },
      "deleted": {
        "title": "Channel Deleted Successfully",
        "content": ""
      },
      "membersAddedSuccess": {
        "title": "Members Added Successfully!",
        "content": "{count} members added to {channelName}"
      },
      "managersAddedSuccess": {
        "title": "Managers Added Successfully!",
        "content": "{count} managers added to {channelName}"
      },
      "memberPostingDisabled": {
        "title": "Successfully updated member posting",
        "content": "Member posting has been disabled"
      },
      "visibilityChangedToPublic": "Channel {channelName} is now public",
      "visibilityChangedToPrivate": "Channel {channelName} is now private",
      "created": {
        "title": "New Channel Created",
        "content": ""
      },
      "error": {
        "createFailed": {
          "title": "Failed to create channel",
          "content": "Please try again later"
        },
        "updateFailed": {
          "title": "Failed to update Channel",
          "content": "Please try again later"
        },
        "managersEditedFailed": {
          "title": "Updating Managers Unsuccessful!",
          "content": ""
        },
        "addFailed": {
          "title": "Adding Managers Unsuccessful!",
          "content": ""
        },
        "addMembersFailed": {
          "title": "Adding Members Unsuccessful!",
          "content": ""
        }
      }
    },
    "createChannel": "CREATE CHANNEL",
    "updateChannel": "UPDATE CHANNEL",
    "addMembers": "Add Members",
    "addManagers": "Add Managers",
    "typeToAddMoreMembers": "Type to add more members",
    "examplePlaceholder": "ex. John or Jane",
    "makeChannelManager": "Make Channel Manager",
    "removeFromChannelManager": "Remove from Channel Manager",
    "manager": "Manager",
    "channelManager": "Channel Manager",
    "noMembersFound": "No members found.",
    "noManagersFound": "No managers found.",
    "removeChannelMember": "Remove Channel Member",
    "removeConfirmationMessage": "Are you sure you want to remove",
    "makeManagerConfirmationMessage": "Are you sure you want to make",
    "makeManagerConfirmationMessage2": "a channel manager in",
    "channelName": "Channel Name",
    "channelIcon": "Channel Icon",
    "addChannel": "Add Channel",
    "editChannel": "Edit Channel",
    "announcementChannel": "Announcement Channel",
    "noChannelsAvailable": "No channels available",
    "makeChannelPrivate": "Make Channel Private",
    "makeChannelPrivateMessage": "Restrict member's access to all channel discussions & interactions.",
    "readOnlyChannel": "Read Only Channel",
    "readOnlyChannelMessage": "Members can view important informations and updates, but only admins/owners of the channel can post here.",
    "createPrivateChannel": "Make this channel private",
    "createPrivateChannelMessage": "Invited Members Only. Non members will not see this space",
    "allowMembersToPost": "Allow members to post",
    "allowMembersToPostMessage": "Enabling this option allows members to create posts and comments",
    "enableMemberPostingConfirmation": {
      "mainMessage": "Enabling member posting will allow all members to create and share posts within the channel.",
      "mainMessage2": "Ensure that all members are aware of the new posting permissions.",
      "pointer1": "This action can be reverted at any time.",
      "pointer2": "All posts created by members will be visible to everyone in the channel."
    },
    "privateChannelTooltip": "You don't have access to this channel",
    "restrictMembersFromPosting": "Restrict Members from posting",
    "restrictMembersFromPostingMessage": "Disabling this option will prevent members from creating or editing posts and comments within the channel.",
    "disableMemberPostingConfirmation": {
      "mainMessage": "Disabling member posting will restrict all members from creating and sharing posts within the channel.",
      "mainMessage2": "Ensure that all members are aware of the new posting restrictions.",
      "pointer1": "This action can be reverted at any time.",
      "pointer2": "All posts created by members before this change will remain visible to everyone in the channel."
    },
    "deleteChannel": "Delete Channel",
    "deleteChannelMessage": "Deleting the channel will permanently lose all the associated data.",
    "deleteChannelMessageWithCourse": "Deleting the channel will permanently lose all the associated data and any courses linked to this channel will become public unless you delete them first.",
    "editChannelName": "Edit Channel Name",
    "editChannelDescription": "Edit Channel Description",
    "channelNamePlaceholder": "e.g Marketing Reports",
    "editManagers": "Edit Managers",
    "channelManagers": "Channel Managers",
    "leaveChannel": "Leave Channel",
    "leaveChannelConfirmation": "Are you sure you want to leave this channel?",
    "changeToPrivateChannel": "Make Channel Private",
    "changeToPrivateChannelMessage": "Making the channel private will restrict the usage of channel for interactions and discussions to it's members only.",
    "changeToPrivateChannelConfirmation": {
      "mainMessage": "Switching this channel to private will limit access to selected members and managers only.",
      "mainMessage2": "Remember to add all desired members to your private channel.",
      "pointer1": "This action is",
      "pointer2": "New members added to channel will have access to all past discussions and interactions within the channel."
    },
    "changeToPublicChannel": "Make Channel Public",
    "changeToPublicChannelMessage": "Making the channel public will allow all group members to view and participate in this channel.",
    "changeToPublicChannelConfirmation": {
      "mainMessage": "Switching this channel to public will make it accessible to all group members.",
      "mainMessage2": "All group members will be able to view and participate in this channel.",
      "pointer1": "All group members will have access to this channel automatically.",
      "pointer2": "Previous private channel content will become visible to all group members."
    },
    "publicChannel": "Public Channel",
    "peopleWhoCanManage": "People who can manage",
    "addChannelHelperText": "Expand community: Add channels for diverse discussions, collaboration and connection.",
    "privateChannel": "Private Channel",
    "removeFromChannel": "Remove from channel",
    "removeConfirmationMessage2": "from this channel",
    "findChannelManagers": "Find Channel Managers",
    "removeChannelManager": "Remove Channel Manager",
    "irreversible": "This action is irreversible"
  },
  "chat": {
    "unblockUser": "Unblock User",
    "blockUser": "Block User",
    "blockMessage1": "You will no longer be able to send messages to this user.",
    "blockMessage2": "This account wont be blocked on the group. You may still be able to see their posts, comments and reactions.",
    "deleteChat": "Delete Chat",
    "deleteChatMessage": "Are you sure that you want to delete this conversation?",
    "block": "Block",
    "conversation": "conversation",
    "youPrefix": "You: ",
    "messageNotSent": "This message was not sent",
    "sending": "Sending",
    "youAndUserKnowEachOther": "You and {name} know each other",
    "startConversationWithHi": "Start a conversation by sending \"Hi\"",
    "accountSettings": "Account settings",
    "blockedUserMessage": "You have blocked { name }, You cannot send or receive messages. Unblock them to start a conversation. To review your list of blocked users, visit your",
    "blockRecipientMessage": "{ name } has blocked you. You cannot send or receive messages.",
    "nothingFound": "Nothing found!",
    "pleaseCheckUsername": "Please check the username and try again",
    "startChatting": "Start Chatting",
    "noChatYet": "Looks like you haven't chatted with anyone yet.",
    "noChatYetMessage": "Search a contact and take the first step!",
    "noConversationsFound": "No conversations found",
    "searchMembersAndStartChatting": "Search members & start chatting",
    "cannotMessageDeletedUser": "You cannot send messages to a deleted user",
    "message": "Message",
    "media": "Media",
    "files": "Files"
  },
  "comments": {
    "reportComment": "Report Comment",
    "reportCommentMessage": "Are you sure you want to report this comment?",
    "deleteComment": "Delete Comment",
    "editComment": "Edit Comment",
    "loadMoreReplies": "Load More Replies",
    "deleteCommentMessage": "Are you sure you want to delete this comment?",
    "writeComment": "Write a comment",
    "comment": "COMMENT",
    "cancel": "CANCEL",
    "save": "SAVE",
    "replyingTo": "Replying to",
    "newComment": "New comment",
    "latest": "Latest",
    "onlyAdminsCanComment": "Only community admins can comment in this channel.",
    "isCommentDisabledForPost": "Comments are disabled for this post.",
    "isCommentDisabledErrorContent": "Comments have been disabled on this post by the author or group admin.",
    "isCommentDisabledErrorTitle": "Comments Disabled",
    "notifications": {
      "saveComment": "Error saving comment",
      "error": "Something went wrong, please try again later.",
      "COMMENT_CONTENT_SIZE_EXCEEDED": "Comment content is too large. Please reduce the size and try again.",
      "COMMENTS_DISABLED": "Comments have been disabled on this post by the author or group admin."
    }
  },
  "embeds": {
    "uploadImage": "Upload Image",
    "addYoutubeVimeoLoomLink": "Add a Youtube, Vimeo or Loom link",
    "uploadAttachment": "Upload PDF, CSV or XLSX files",
    "addAttachment": "Add Attachment",
    "allowedTypes": "SVG, PNG, JPG or GIF (max. 800x400px)",
    "placeholder": "Add a Youtube, Vimeo or Loom link",
    "uploadVideo": "Upload/Link Video",
    "uploadVideoPlaceholder": "Add a Youtube, Vimeo or Loom link",
    "uploadVideoAllowedTypes": "Upload an MP4 video file",
    "addEmoji": "Add emoji",
    "emojiSuggestion": "Opens Emoji picker",
    "addGif": "Add GIF",
    "gifSuggestion": "Opens GIF picker",
    "addImage": "Add image",
    "imageSuggestion": "Opens your gallery",
    "addVideo": "Add video",
    "videoSuggestion": "Opens your gallery",
    "selectFile": "Select file",
    "attachmentSuggestion": "Opens file manager",
    "takePhoto": "Take photo",
    "uploadPhotoVideo": "Upload photo/video",
    "limitExceeded": "Limit Exceeded",
    "limitExceededMessage": "You can't attach more than 4 files",
    "errorWhileUploadingFile": "Error while uploading file! Please try again",
    "notifications": {
      "uploadError": "Error uploading file",
      "FILE_SIZE_EXCEEDED": "File size exceeds the maximum upload limit of 50MB.",
      "VIDEO_SIZE_EXCEEDED": "Video size exceeds the maximum upload limit of 1GB."
    },
    "clickToUpload": "Click to upload",
    "orDragAndDrop": "or drag and drop",
    "validUrl": "Valid URL is needed",
    "enterSomeText": "Enter some text",
    "addLink": "Add Link",
    "text": "Text",
    "addVideoLink": "Or, add a YouTube, Vimeo, Loom, or Wistia video link.",
    "uploadVideoAndImages": "Upload videos and images",
    "recommendedAspectRatio": "Recommended aspect ratio {ratio}",
    "addHashtag": "Tag channels, events and courses",
    "hashtagSuggestion": "Hashtag Suggestion"
  },
  "tabSwitcher": {
    "discussion": "Discussion",
    "learning": "Learning",
    "members": "Members",
    "people": "People",
    "leaderboard": "Leaderboard",
    "channels": "Channels",
    "groups": "Groups",
    "more": "More",
    "home": "Home",
    "discover": "Discover",
    "courses": "Courses",
    "communities": "Communities"
  },
  "groupInfo": {
    "pinGroup": "Pin Group",
    "unpinGroup": "Unpin Group",
    "maxPinnedGroupsLimit": "Only up to 4 groups can be pinned",
    "publicGroup": "Public Group",
    "privateGroup": "Private Group",
    "coverImage": "Group Cover",
    "members": "Members",
    "posts": "Posts",
    "admin": "Admin",
    "settings": "SETTINGS",
    "inviteMembers": "INVITE MEMBERS",
    "answerQuestions": "Answer Questions",
    "toJoin": "to join {name}",
    "leaveGroup": "Leave Group",
    "leaveGroupConfirmMessage": "Are you sure you want to leave this group? You will lose access to all paid courses, paid events, and your group membership.",
    "leaveGroupSuccessTitle": "You have left the group",
    "leaveGroupSuccessMessage": "You have successfully left the group.",
    "leaveGroupErrorTitle": "Unable to leave the group",
    "leaveGroupErrorMessage": "Something went wrong while leaving the group. Please try again.",
    "groupActions": "Group actions",
    "changeRole": "Change Role",
    "removeFromGroup": "Remove from group",
    "contributor": "Contributor",
    "membershipAnswers": "Membership answers",
    "unbanMember": "Unban Member",
    "banFromGroup": "Ban from group",
    "requestedOn": "Requested on",
    "invitedOn": "Invited on",
    "joinedOn": "Joined",
    "noMembersFound": "No members found.",
    "youAreAllCaughtUp": "You're all caught up—no members here right now!",
    "banUserConfirmation": "Are you sure you want to ban this user from the group?",
    "deleteContentCheckbox": "Delete all content created by this user",
    "active": "Active",
    "admins": "Admins",
    "contributors": "Contributors",
    "requested": "Requested",
    "banned": "Banned",
    "invited": "Invited",
    "paymentReceived": "Payment Received",
    "paymentInitiated": "Payment Initiated",
    "answeredQuestions": "Answered Questions",
    "answeredQuestionsMessage": "answered the following question to join",
    "darkMode": "Dark Mode",
    "darkModeMessage": "Adjust the appearance of Community to reduce glare and give your eyes a break.",
    "accessGranted": "Access Granted: Begin Your Learning Adventure.",
    "stepIntoAction": "Step into action! Let's collaborate and have some fun.",
    "viewMembersAndMemberDetails": "View members and member details",
    "reviewContentReportsAndMore": "Review content reports and more",
    "toReview": "To Review",
    "switchToOtherGroups": "Switch to other groups",
    "placeholders": {
      "yourAnswer": "Your Answer"
    },
    "notifications": {
      "userBanned": "User banned from the group successfully",
      "somethingWentWrong": "Something went wrong. Please try again later."
    },
    "membershipSettings": "Membership Settings",
    "paymentFailed": "Payment failed!",
    "paymentFailedMessage": "Payment failed, your request to join the group has been declined.",
    "gamification": {
      "addRewards": "Add Rewards",
      "title": "Title",
      "description": "Add Description",
      "textbox": "Textbox",
      "singleSelect": "Single Select",
      "multipleSelect": "Multiple Select",
      "question": "Question",
      "validations": {
        "titleRequired": "Please provide title",
        "descriptionRequired": "Please provide description",
        "somethingWentWrong": "Something went wrong. Please try again later.",
        "updatedRewards": "Updated Rewards"
      },
      "settings": {
        "updatedRewards": "Updated Rewards"
      }
    },
    "customCode": {
      "advanced": "Advanced",
      "testPreview": "Test Preview",
      "enableConfirmationMessage": "Enable it only once you verify test preview",
      "testPreviewMessage": "This will open a new tab with the test preview of your community. You can use this to check if your custom code is working as expected.",
      "liveMode": "Live Mode",
      "customJS": "Custom JS",
      "customCSS": "Custom CSS",
      "trackingCode": "Tracking Code",
      "headerCode": "Header Code",
      "footerCode": "Footer Code"
    },
    "branding": {
      "brandYourGroup": "You can brand your group as per your choice here",
      "updateBranding": "Update Branding",
      "clickToUploadFavicon": "Click to upload Favicon",
      "dragAndDropFavicon": "Drag and drop a {types} (Aspect Ratio 1:1)",
      "clickToUploadCover": "Click to upload Cover",
      "dragAndDropCover": "Drag and drop a {types} (Aspect Ratio 16:9)",
      "clickToUploadLogo": "Click to upload Group Logo",
      "dragAndDropLogo": "Drag and drop a {types} (Aspect Ratio 1:1)",
      "aspectRatioMustBe1To1": "The aspect ratio of the image must be 1:1",
      "aspectRatioMustBe16To9": "The aspect ratio of the image must be 16:9",
      "favicon": "Favicon",
      "coverImage": "Cover Image",
      "logo": "Logo",
      "invalidFileFormat": "Oops! Invalid File Format/Type.",
      "pleaseUploadImageType": "Supported file types: {types}"
    },
    "groupAppearance": {
      "description": "You can configure your group appearance as per your choice here",
      "slug": "Update your group appearance here",
      "colorMode": "Color Mode",
      "previewTheLook": "Preview how your group will look in light and dark mode",
      "light": "Light",
      "dark": "Dark",
      "communityTheme": "Community Theme",
      "customTheme": "Custom Theme",
      "windowGradient": "Window Gradient",
      "applyGradientColorsToYourSidebarAndTopbar": "Apply gradient colors to your sidebar and topbar",
      "labels": {
        "sidebarBackground": "Sidebar Background",
        "primary": "Primary",
        "secondary": "Secondary",
        "tertiary": "Tertiary",
        "surface": "Surface",
        "fontPrimary": "Primary Font",
        "fontSecondary": "Secondary Font",
        "fill": "Fill Color",
        "border": "Border",
        "error": "Error",
        "background": "Background",
        "option": "Option"
      },
      "customThemes": {
        "default": "Default",
        "zestyCitrus": "Zesty Citrus",
        "royalVelvet": "Royal Velvet",
        "sunnyDelight": "Sunny Delight",
        "lushMeadow": "Lush Meadow",
        "azureDreams": "Azure Dreams",
        "bubblegumBliss": "Bubblegum Bliss",
        "ivoryWhisper": "Ivory Whisper",
        "midnightDeep": "Midnight Deep"
      },
      "unsavedChanges": "Unsaved Changes",
      "unsavedChangesMessage": "You have unsaved themes changes, are you sure you want to revert the changes?"
    },
    "promotionalLinks": {
      "promotionalLinks": "Promotional Links",
      "createPromotionalLinkDescription": "Create promotional links for your group",
      "addPromotionalLink": "Add Link",
      "deleteLink": "Delete Link",
      "deleteLinkConfirmation": "Are you sure you want to delete this link?",
      "labels": {
        "description": "Description",
        "url": "URL",
        "private": "Private",
        "privateLinksDescription": "Private links are only visible to group members"
      },
      "placeholders": {
        "enterLinkDescription": "Enter link description",
        "enterLinkURL": "Enter link URL"
      },
      "addPromotionalLinkDescription": "Create promotional links for your group",
      "ariaLabels": {
        "editLink": "Edit Link",
        "deleteLink": "Delete Link"
      }
    },
    "membershipQuestions": {
      "addQuestion": "Add Question",
      "editQuestion": "Edit Question",
      "editLevelName": "Edit Level Name",
      "addOption": "Add Option",
      "level": "Level",
      "name": "Name",
      "addMembersQuestionsDescription": "Add members questions to ask when they request access to your group",
      "enableMembershipQuestions": "Enable Membership Questions",
      "membershipQuestions": "Membership Questions",
      "deleteQuestion": "Delete Question",
      "deleteQuestionConfirmation": "Are you sure you want to delete this question?",
      "labels": {
        "textBox": "Textbox",
        "singleSelect": "Single Select",
        "multipleSelect": "Multiple Select",
        "enableMembershipQuestions": "Add at least one question to enable membership questions"
      },
      "validations": {
        "questionRequired": "Please enter question",
        "answerOptionsRequired": "Minimum of two options is required, and they must be unique",
        "somethingWentWrong": "Something went wrong. Please try again later.",
        "updatedQuestions": "Updated Group Membership Questions",
        "levelNameRequired": "Please enter level name",
        "updatedLevelName": "Updated Level Name"
      },
      "placeholders": {
        "enterLevelName": "Level Name",
        "selectOne": "Select one",
        "keepItShort": "keep it short..",
        "exampleOffer": "e.g. 10% off on first purchase"
      },
      "privacyNotice": "I understand that my answers will be saved and visible to group administrators.",
      "ariaLabels": {
        "editQuestion": "Edit Question",
        "deleteQuestion": "Delete Question"
      }
    },
    "gamificationAndRewards": {
      "title": "Customize Levels & Rewards",
      "description": "Customize level names and add rewards for better engagement of members",
      "gamification": "Gamification",
      "rewards": "Rewards",
      "addRewards": "Add Reward",
      "ariaLabels": {
        "toggleGamification": "Toggle Gamification Options"
      }
    },
    "invitations": {
      "invitationSentSuccessfully": "Invitation Sent Successfully",
      "invitationSentSuccessfullyDescription": "Invitation sent to {email}",
      "shareGroupLink": "Share your group link",
      "inviteMember": "Invite Member",
      "inviteMemberDescription": "Build your community by inviting a new member",
      "inviteViaEmail": "Invite via Email",
      "invitedMembersWillBeAutoApproved": "Invited members will be auto approved to join group",
      "sendInvite": "SEND INVITE",
      "permissionDenied": "You do not have permission to invite members. Kindly contact your administrator.",
      "notifications": {
        "INVITATION_CREATE_UNAUTHORIZED": "You do not have permission to send invitations.",
        "INVITATION_CREATE_GROUP_DISALLOWS_INVITE": "This group does not allow members to invite others.",
        "INVITATION_CREATE_ALREADY_INVITED": "This user has already been invited.",
        "INVITATION_CREATE_ALREADY_MEMBER": "This user is already a member of the group."
      },
      "labels": {
        "giveAdministrativePrivileges": "Give Administrative Privileges",
        "giveAdministrativePrivilegesDescription": "Allow this member to perform all administrative actions",
        "name": "Name",
        "email": "Email",
        "nameLabel": "Name",
        "emailLabel": "Email"
      },
      "placeholders": {
        "enterName": "Enter Name",
        "enterEmail": "Enter Email"
      }
    },
    "groupDetails": {
      "updateGroupDetails": "Update Group Details",
      "updateGroupDetailsDescription": "Update your group details here",
      "slugNotAvailable": "Group Slug Not Available",
      "description": "Elaborate on the nature of discussions that will take place within the group",
      "publicDescription": "Anyone can see the group posts and other members of the group",
      "privateDescription": "Only members can see the group posts and other members of the group",
      "accessibleFromSwitcher": "Accessible from switcher",
      "accessibleFromSwitcherDescription": "Your group will be visible to non group members in the switcher",
      "allowMembersToInvite": "Allow members to invite new members",
      "allowMembersToInviteDescription": "Hides the invite button for members when turned off. Members can only invite others if this is enabled.",
      "showMandatoryInfoModal": "Show mandatory profile modal",
      "showMandatoryInfoModalDescription": "When enabled, members will be prompted to complete their profile information when joining the group.",
      "slug": "Group Slug",
      "discovery": {
        "title": "Discovery",
        "description": "Get discovered by millions of active users. The group will be visible on the discover page once you have more than 10 members.",
        "discoverChannels": "Discover Channels",
        "joinGroupToExploreAllChannels": "Join the group to explore all the channels",
        "categoryIsUsedOnlyOnGokollab": "Category is used only on Gokollab",
        "categoryAutomaticallySuggested": "Category is automatically suggested using AI based on your group's title and description. For the most accurate suggestion, ensure your group details clearly reflect its purpose and topics.",
        "categoryRefreshLimited": "Category refresh is limited to once every 24 hours"
      },
      "placeholders": {
        "description": "Enter a brief description"
      },
      "validations": {
        "nameRequired": "Please enter valid group name!",
        "slugRequired": "Please enter valid group slug!",
        "specialCharacterNotSupported": "Special Character not supported",
        "descriptionRequired": "Group Description is required!",
        "emailRequired": "Please enter valid email!",
        "fullNameRequired": "Please enter valid name!"
      },
      "labels": {
        "groupName": "Group Name"
      }
    },
    "subscriptions": {
      "manageSubscriptions": "Manage your Subscriptions",
      "viewAndManageGroupSubscriptions": "View and manage group subscriptions",
      "paymentIntegrationMissingMessage": "Please integrate payments in location to enable paid groups",
      "price": "Price",
      "currency": "Currency",
      "priceDisplay": "{symbol}{price}{suffix}",
      "priceInterval": "/{interval}",
      "oneTime": " One Time",
      "priceDeletedAlert": "Payment product is out of sync, Click here to resync",
      "intervals": {
        "month": "Month",
        "year": "Year",
        "week": "Week",
        "day": "Day"
      },
      "addNewPrice": "Add New Price",
      "editPrice": "Edit Price",
      "addPrice": "Add Price",
      "subscriptionType": {
        "recurring": "Recurring",
        "oneTime": "One Time"
      },
      "billingPeriod": {
        "monthly": "Monthly",
        "annually": "Annually",
        "weekly": "Weekly",
        "daily": "Daily"
      },
      "ariaLabels": {
        "freeMembership": "Free Membership Radio Button",
        "paidMembership": "Paid Membership Radio Button"
      }
    },
    "menuOptions": {
      "details": "Details",
      "subscriptions": "Subscriptions",
      "branding": "Branding",
      "themes": "Themes",
      "tabsConfiguration": "Show / Hide Tabs",
      "membershipQuestions": "Membership Questions",
      "gamificationAndRewards": "Gamification & Rewards",
      "links": "Links",
      "newsletter": "Newsletter",
      "reportedContent": "Reported Content",
      "discovery": "Discovery",
      "import": "Import"
    },
    "newsletter": {
      "title": "Newsletter",
      "subheading": "Your Community Digest",
      "frequency": "Newsletter Frequency",
      "description": "A summary of popular posts, member activity and events from this group",
      "time": "Time",
      "weekday": "Weekday",
      "monthDay": "Month day",
      "lastDay": "Last day",
      "selectFrequency": "Select frequency",
      "frequencies": {
        "off": "Off",
        "daily": "Daily",
        "weekly": "Weekly",
        "biweekly": "Bi-weekly",
        "monthly": "Monthly"
      }
    },
    "tabConfiguration": {
      "title": "Show / Hide Tabs",
      "description": "Control which tabs appear in your community. Enable or disable each tab to create a focused, streamlined experience for your members.",
      "discussionDescription": "Start or join conversations to share updates, ideas, and insights with your community.",
      "learningDescription": "Create and manage courses that help members gain new skills or knowledge.",
      "eventsDescription": "Plan, organize, and view upcoming sessions, workshops, or community events.",
      "leaderboardDescription": "Recognize top-performing members and encourage healthy engagement through rankings.",
      "membersDescription": "Manage all members and roles. This tab will remain visible to admins even when disabled, so member management is always accessible.",
      "aboutDescription": "Introduce your community's purpose, values, and background to help members connect.",
      "discussionTooltip": "Discussion is a core community tab and can't be disabled",
      "aboutTooltip": "About tab is required to provide essential community information and can't be disabled."
    },
    "groupSettings": {
      "groupSettings": "Group Settings",
      "changeGroupType": "Change Group Type",
      "changeGroupTypeDescriptionPrivateToPublic": "Changing to a public group means all pending requests will be accepted automatically, and content will become publicly visible. Proceed?",
      "changeGroupTypeDescriptionPublicToPrivate": "Changing to a private group means new members need approval and content stays hidden until they're approved. Proceed?",
      "changeGroupTypeConfirmation": "Are you sure you want to change group type?",
      "changeGroupTheme": "Change Group Theme",
      "changeGroupThemeDescription": "This will change the theme for all the group members. Are you sure you want to change group theme?",
      "updatedGroupDetails": "Updated Group Details",
      "unableToSaveDetails": "Oops! Unable to save details.",
      "groupNameIsRequired": "Group Name is required",
      "groupDescriptionIsRequired": "Group Description is required",
      "groupSlugIsRequired": "Group Slug is required",
      "groupSlugMustContainOnly": "Group Slug must contain only lowercase letters, numbers, and hyphens",
      "groupSlugAlreadyExists": "Group Slug Already Exists. Please use a different slug as this one is already taken",
      "groupSlugRestricted": "This slug matches with one of our restricted keywords for community links. Please use a different slug",
      "pleaseTryAgainLater": "Please try again later",
      "unsavedChangesMessage": "You have unsaved group slug changes, are you sure you want to revert them?"
    },
    "import": {
      "header": "Import Skool Group Members and their Content",
      "credentialDescription": "Enter your Skool credentials to import your group members and their content",
      "csvUploadDescription": "Choose .csv file to import contacts from Skool",
      "loginFailed": "You have entered an invalid email or password. Please try again.",
      "proceedWithImport": "Proceed with Import?",
      "iAgree": "I agree",
      "importTerms": "By clicking \"I agree,\" you confirm and acknowledge that you have engaged us as an independent contract to perform services on your behalf (\"Services\"). The Services include the transfer of certain data, information, content, intellectual property or any other material (\"Data\") from a Releasing Platform Account to a Receiving Platform Account. You represent and warrant that (i) you are the rightful owner of the Data in the Releasing Platform Account, (ii) you have the rights to grant us access to the Releasing Platform Account for the purpose of performing the Services, and (iii) the transfer of the Data will not infringe any third party's intellectual property rights or violate any third party contracts. You agree to indemnify, defend, and hold us harmless for any third party claims that arise as a result of your breach of the above reps and warranties.",
      "pleaseDownloadCSV": "Please download the .CSV file",
      "step01": "Step 01-",
      "step02": "Step 02-",
      "uploadCSV": "Upload your .CSV",
      "step01Description": "Fill in or update any missing information for group members such as emails, first name etc. Ensure that the CSV is uploaded in",
      "thisTemplate": "this template",
      "importCSV": "Import .CSV",
      "reSyncData": "Re-sync your data before downloading.",
      "refreshUserList": "Refresh user list",
      "reSyncDataDescription": "If new users are added in the meanwhile, we suggest you to refresh your list and download the CSV.",
      "pleaseDontChangeProfileSlug": "Please don't change profile slug.",
      "selectFile": "Select File",
      "changeFile": "Change File",
      "importMembersFailedText": "This may be because they are missing email addresses. Please check your import file and try again with valid email addresses for these members.",
      "upload": "Upload",
      "tryAgain": "Try Again",
      "importerAnotherGroup": "Start New Import",
      "syncAllPosts": "Sync All your Post and Comment",
      "membersCouldNotBeAdded": "Members could not be added to the group.",
      "importMembersSuccess": "We have sent an email to all individual group members, confirming their membership in the group and providing them with access details. This helps to ensure all members are informed and can access with the group effectively.",
      "importMembersAdded": "members have been successfully added to the group",
      "postsNotSynced": "Remaining Posts could not be synced to the group. This may be because the post authors were not imported successfully.",
      "migrationFailed": "Migration failed. Please try again.",
      "migrationCompleted": "Migration completed!",
      "migrationInProgress": "Migration in progress",
      "createProfile": "Create Profile",
      "enterCredentials": "Enter Credentials",
      "uploadingInProgress": "Upload in progress!",
      "listMembers": "List of members is being",
      "downloaded": "downloaded",
      "uploaded": "uploaded",
      "listPostsDownloaded": "List of posts is downloaded.",
      "listPostsDownloading": "List of posts is being downloaded.",
      "posts": "posts",
      "members": "members",
      "imported": "imported",
      "step1": "Step 1",
      "step2": "Step 2",
      "step1Description": "Create a Member Profile in Skool Group.",
      "step1Description2": "(including Name, Email ID and Password)",
      "step2Description": "Enter Skool Member Credentials",
      "skoolUrlPlaceholder": "Enter your Skool's group URL",
      "emailPlaceholder": "Enter your Skool's Email ID",
      "emailTooltip": "Enter the email associated with your Skool account",
      "passwordPlaceholder": "Enter your Skool's Password",
      "confirm": "Confirm",
      "validation": {
        "skoolUrl": "Please enter a valid Skool URL",
        "email": "Email is required",
        "password": "Password is required"
      }
    },
    "approved": "Approved",
    "pending": "Pending",
    "rejected": "Rejected"
  },
  "invitations": {
    "intent": "Help this community grow!",
    "cancelInvitation": "Cancel Invitation",
    "inviteMembers": "Invite members to collaborate on this community.",
    "inviteLink": "Invite link",
    "invitationLink": "invitation link",
    "buildYourCommunity": "Build Your community!",
    "inviteMembersToCollaborate": "You've created a new community! Invite members to collaborate on this community.",
    "invite": "Invite",
    "basicInformation": "Basic Information",
    "permissions": "Permissions"
  },
  "createPost": {
    "title": "Create New Blog Post",
    "placeholder": "What's on your mind",
    "liveStream": "Live Stream",
    "slug": "Blog post URL Slug",
    "titleHelp": "The title, description and image will be used for SEO Meta Tag",
    "nameLabel": "Blog post title",
    "nameValidation": "Title is required",
    "descriptionLabel": "Post description",
    "descriptionHelp": "Give a short description for viewers to get a glimpse of the post. Works best between 100 - 250 characters",
    "descriptionValidation": "Description is required",
    "createLabel": "Create post",
    "image": "Blog post image",
    "imageDescription": "Recommended size is 600px * 400px",
    "notificationTitle": "Blog post Created",
    "notificationErrorTitle": "Failed to create blog post",
    "postingIn": "Posting in",
    "editingIn": "Editing in"
  },
  "post": {
    "downloadRecording": "Download Recording",
    "deletePost": "Delete Post",
    "reportPost": "Report Post",
    "editPost": "Edit Post",
    "createPost": "Create Post",
    "publish": "Post",
    "publishPost": "Publish Post",
    "addChannel": "Add Channel",
    "selectChannel": "Please select channel",
    "addLink": "Add Link",
    "removeLink": "Remove Link",
    "update": "Update",
    "unsavedChanges": "You have unsaved changes",
    "unsavedChangesMessage": "Your unsaved changes will be lost. Do you still want to proceed?",
    "unpinFromChannel": "Unpin",
    "unpinFromHome": "Unpin",
    "deletePostConfirmation": "Are you sure you want to delete this post?",
    "reportPostConfirmation": "Are you sure you want to report this post?",
    "postNotFound": "Post not found",
    "postNotFoundMessage": "The Post you are trying to view is either deleted or does not exists.",
    "loadMoreComments": "Load more comments",
    "channelNotFound": "Channel not found",
    "isCurrentlyLive": "is currently live",
    "isStartingNow": "is starting now",
    "isHappeningInMinutes": "is happening in {minutes} mins",
    "isHappeningInHours": "is happening in {hours} hour | is happening in {hours} hours",
    "publicChannel": "Public channel",
    "privateChannel": "Private channel",
    "featured": "Featured",
    "featuredAbout": "About Featured",
    "noPostsFound": "No posts found",
    "pinInfo": "You can pin items to be displayed at the top of the group, including posts, rules and hashtags.",
    "pinInfoEveryone": "Everyone in the group will see these items.",
    "pinInfoRemainVisible": "Pinned items remain visible until you unpin them.",
    "pinInfoNewestItem": "As you pin items, the newest item appears at the front of the list.",
    "onlyVisibleToAdmins": "Only visible to admins",
    "featuredAboutDescription": "Your admins have pinned these items for the group to see.",
    "channelNotFoundMessage": "You are no longer a member of the channel you are trying to access or the channel has been deleted.",
    "notifications": {
      "unpinned": "Unpinned!",
      "pinned": "Pinned!",
      "reported": "Post has been reported!",
      "error": "Something went wrong!",
      "isCommentDisabled": "Comments disabled!",
      "isCommentEnabled": "Comments enabled!",
      "createPost": "Error creating post",
      "editPost": "Error editing post",
      "POST_CONTENT_SIZE_EXCEEDED": "Post content is too large. Please reduce the size and try again."
    },
    "movePostToChannel": "Move to Channel",
    "pin": "Pin",
    "pinToHome": "Pin to Home",
    "pinToChannel": "Pin to Channel",
    "whatIsYourTitle": "What is your title?",
    "postMovedToChannel": "Post moved to {channelName} channel",
    "upcomingEvent": "Upcoming Event",
    "turnOffCommenting": "Turn off commenting",
    "enableComments": "Enable Comments",
    "disableComments": "Disable Comments",
    "moveToPrivateChannelConfirmation": {
      "title": "Move to Private Channel",
      "message": "You are about to move this post to a private channel. Only members of that private channel will be able to see it. Do you want to continue?"
    },
    "onlyAdminsCanPost": "Only community admins can post in this channel."
  },
  "reaction": {
    "noLikes": "No Likes",
    "andOthers": "and {count} others"
  },
  "UIConfirmation": {
    "privateGroup": "This group is private",
    "privateGroupMessage": "You need to be a member of this group to access group specific information. Please request access by clicking the Join Group button."
  },
  "notifications": {
    "noNotificationsYet": "No notifications yet",
    "whenYouGetNotifications": "When you get notifications, they’ll show up here",
    "markAllAsRead": "Mark all as read",
    "notifications": "Notifications",
    "all": "All",
    "unread": "Unread",
    "checkNotifications": "Login to check notifications",
    "noNotifications": "No notifications!",
    "redirectedFromOldSlug": {
      "title": "You've been redirected to the updated community link",
      "content": "This has been done to enhance SEO performance for this community. Please update your bookmarks with this new URL."
    }
  },
  "joinGroupModal": {
    "wahoo": "Wahoo! 🎉, Request Sent Successfully",
    "reviewRequestSoon": "Our group administrators will review your request soon. Please be patient, and we'll notify you once your membership is approved.",
    "nonMemberMessage": "You need to be part of this group to like and comment on posts",
    "subscribeFor": "Subscribe for",
    "joinGroup": "JOIN GROUP",
    "membershipPending": "MEMBERSHIP PENDING",
    "viewMembershipAnswers": "View Membership Answers",
    "requested": "Requested",
    "dayFreeTrial": "Day Free Trial",
    "notPartOfGroup": "You are not part of this group yet, your membership request is in review. Once an admin approves your request we will notify you",
    "pleaseAnswerMembershipQuestions": "Please answer the membership questions to join this group",
    "answerQuestions": "Answer Membership Questions"
  },
  "userProfilePopover": {
    "active": "Active",
    "longAgo": "long ago",
    "chatDisabled": "This user has disabled their chat",
    "pointsToLevelUp": "points to level up",
    "profile": "Profile",
    "deletedUser": "Deleted User",
    "joined": "Joined",
    "contributions": "Contributions"
  },
  "courses": {
    "by": "By",
    "free": "Free",
    "unknownInstructor": "Unknown Instructor",
    "courseRestricted": "This course is restricted",
    "courseDeleted": "This course has been deleted",
    "noMatchingCourseFound": "No matching course found",
    "addCourse": "Add Course",
    "updateCourse": "Update Course",
    "access": "All members have access",
    "unableToAddCourse": "Oops! Unable to add course",
    "pleaseTryAgainLater": "Please try again later",
    "paymentIntegrationMissing": "Oops! Payment integration is missing",
    "paymentIntegrationMissingMessage": "Please integrate payments in location to enable paid courses",
    "course": "Course",
    "courseInThisGroup": "an existing course in this group",
    "courseLinkCopied": "Course Link Copied!",
    "buyNow": "BUY NOW",
    "locked": "LOCKED",
    "buyCourse": "BUY COURSE",
    "open": "OPEN",
    "moveCard": "Move Card",
    "courseViewMessage": "You need to be part of this group to view the courses.",
    "deleteCourse": "Delete Course",
    "deleteCourseConfirmation": "Are you sure you want to delete this Course?",
    "courseAccessNotGranted": "Course Access Not Granted",
    "courseAccessNotGrantedMessage": "We're currently working on granting you access to the course. Kindly refresh the page and try again in a moment.",
    "autoRenewsAfter": "Automatically renews after",
    "oneTimePayment": "One time payment",
    "emptyCoursesMessage": "Looks like a ghost town. Nothing to see here",
    "updatedSuccessfully": "Course updated successfully",
    "addedSuccessfully": "Course added successfully",
    "createCourse": "Create New Course",
    "emptyCourseLibrary": "Your Course Library is Empty!",
    "createdOutsideGokollabMessage": "This community was created outside of Gokollab & made discoverable. To create new courses, please log in to the community from it's source platform",
    "createCourseOnGokollabMessage": "Create a new course on Gokollab to make it available for your community members.",
    "or": "or",
    "createNewOne": "create a new one",
    "labels": {
      "selectCourse": "Select Course",
      "courseVisibility": "Course Visibility",
      "courseAccess": "Course Access",
      "coursePrice": "Course Price",
      "subscriptionType": "Subscription Type",
      "billingPeriod": "Billing Period",
      "testMode": "Test Mode",
      "turnOnTestPayments": "Turn on test payments using a test card",
      "currency": "Currency",
      "trialDays": "Trial Days",
      "recurring": "Recurring",
      "free": "Free",
      "oneTime": "One Time",
      "refresh": "Refresh",
      "accessStartsAtDay": "Access starts at Day",
      "maximumYouCanEnterIs365": "Maximum you can enter is 365",
      "allMembers": "All Members",
      "levelUnlock": "Level Unlock",
      "buyNow": "Buy Now",
      "timeUnlock": "Time Unlock",
      "gamificationLevel": "Gamification Level",
      "privateChannel": "Private Channel",
      "private": "Private",
      "marketingChannel": "Marketing Channel",
      "selectCurrency": "Select Currency"
    },
    "placeholders": {
      "enterPrice": "Enter price",
      "enterTrialDays": "Enter trial days",
      "selectCurrency": "Select one",
      "selectBillingPeriod": "Select one",
      "billingPeriod": "Select billing period"
    },
    "validations": {
      "validPrice": "Please enter valid price",
      "required": "Please select a course",
      "validMembershipPrice": "Please enter valid membership price",
      "validTrialDays": "Please enter valid trial days",
      "requiredSubscriptionType": "Please select subscription type",
      "courseVisibility": "Please select course visibility",
      "requiredGamificationLevel": "Please select gamification level",
      "requiredPrivateChannel": "Please select private channel",
      "validAccessStartDay": "Please enter valid access start day"
    },
    "descriptions": {
      "buyNowDescription": "This course is accessible upon purchase",
      "timeUnlockDescription": "Members Unlock after X days",
      "levelUnlockDescription": "Members only at a certain level will be able to unlock",
      "allMembersDescription": "All members have access to this course",
      "privateChannelDescription": "Members of a private channel",
      "privateDescription": "Access granted by admin only"
    },
    "helperText": {
      "levelBased": "Level-Based",
      "timeLimited": "Time-Limited",
      "privateBased": "Private",
      "free": "Free",
      "levelAvailableAt": "Available at level 0{value}",
      "timeLimitedAfterJoining": "Accessible {value} {day} after joining the group",
      "day": "day",
      "days": "days",
      "purchaseToUnlockAccess": "Purchase this course to unlock access",
      "privateCourse": "Private course - Access granted by admin only",
      "locked": "This course is locked",
      "unlockAtLevel": "This course will unlock at level {level}",
      "unlockAfterDays": "This course will unlock after {days} {dayText}",
      "privateChannelBased": "Private Channel-Based",
      "externalAccess": "Other Group/Offer"
    },
    "manageAccess": {
      "manageCourses": "Manage Courses",
      "revokeCourseAccess": "Manage Courses",
      "grantCoursesAccess": "Grant Courses",
      "removeAccess": "Remove access",
      "grantAccess": "Grant access",
      "grant": "Grant",
      "clear": "Clear",
      "selectAll": "Select All",
      "revokeAccessConfirmTitle": "Remove course access?",
      "revokeAccessConfirmMessage": "Are you sure you want to remove access to \"{courseName}\" for {userName}?",
      "externalAccessTooltip": "Cannot remove: user has access from another group or offer",
      "cannotRevokeAutoAccess": "Cannot remove: access automatically granted based on course settings (paid, level, time, or free)",
      "searchPlaceholder": "Search for courses",
      "noCoursesFound": "No courses found",
      "noCoursesSelected": "No courses selected yet",
      "noCoursesAvailable": "No courses available to grant",
      "noSearchResults": "No search results",
      "failedToLoadCourses": "Failed to load courses",
      "accessRevoked": "Course access removed successfully",
      "failedToRevokeAccess": "Failed to remove course access",
      "accessGranted": "Course access granted successfully",
      "multipleAccessGranted": "{count} courses granted successfully",
      "failedToGrantAccess": "Failed to grant course access"
    },
    "ariaLabels": {
      "courseCard": "Course Card",
      "courseCardActions": "Course Card Actions",
      "editCourse": "Edit Course",
      "deleteCourse": "Delete Course",
      "moveCard": "Move Card",
      "copyLink": "Copy Link",
      "cardImage": "Course card image"
    }
  },
  "about": {
    "notifications": {
      "errorUploadingFile": "Error uploading file"
    },
    "uploadLinkVideo": "Upload/Link Video",
    "removeMedia": "Remove {fileName} Media"
  },
  "leaderboard": {
    "level": "Level",
    "lastUpdated": "Last updated",
    "members": "Members",
    "percentOfMembers": "{percentage}% of members",
    "rewards": "Rewards",
    "allTime": "All time",
    "pointsToLevelUp": "points to level up",
    "points": "Points",
    "leaderboard7d": "Leaderboard (7-days)",
    "leaderboard30d": "Leaderboard (30-days)",
    "leaderboardAlltime": "Leaderboard (All time)",
    "yourRank": "Your rank",
    "noActivityToShow": "No activity to show",
    "rewardsWillBeDisplayedHere": "Rewards will be displayed here",
    "seeAllLeaderboards": "See all leaderboards",
    "addRewards": "Add Rewards",
    "howPointsWork": "You earn points when other members like your posts or comments. 1 like = 1 point. This encourages users to produce quality content and interact with other members in their community.",
    "levels": "Levels",
    "levelsDescription": "As you gain points, you level up. Your level is shown at the bottom right of your avatar. The number of points required to get to the next level is shown via the progress bar on Leaderboard screen.",
    "pointsAndLevels": "Points & Levels"
  },
  "events": {
    "createEvent": "Create Event",
    "dragAndDrop": "Drag and Drop a SVG, PNG or JPG (Max 800 x 400px)",
    "editEvent": "Edit Event",
    "addEvent": "Add Event",
    "paymentDetails": "Payment Details",
    "event": "Event",
    "goBack": "Go Back",
    "cancelEdit": "Cancel Edit",
    "cancelEvent": "Cancel Event",
    "next": "Next",
    "saveEvent": "Save Event",
    "editRecurringEvent": "Edit recurring event",
    "thisEvent": "This event",
    "thisAndFollowingEvents": "This and following events",
    "ok": "OK",
    "deleteRecurringEvent": "Delete recurring event",
    "allEvents": "All events",
    "adminsFreeForPaidEvents": " * Admins can register for paid events for free",
    "deleteEvent": "Delete Event",
    "onceEventDeleted": "Once event deleted, will not show in your calendar.",
    "toRegister": "to Register",
    "calendar": "Calendar",
    "addToCalendar": "Add to calendar",
    "declineRegistration": "Decline",
    "paymentFailedMessage": "Your payment failed due to some unforeseen circumstances! Please try again later.",
    "upcoming": "Upcoming",
    "noMoreEvents": "No more events to show",
    "joinGroupToRegister": "You need to be part of this group to register for this event",
    "past": "Past",
    "youHaveRegisteredForOneEvent": "You have registered for 1 event. We will send you reminder a day before each event.",
    "upcomingEvents": "Upcoming Events",
    "noUpcomingEvents": "No Upcoming Events",
    "pastEvents": "Past Events",
    "noPastEvents": "No Past Events",
    "noMatchingEventFound": "No matching event found",
    "recordings": "Recordings",
    "week": "Week",
    "month": "Month",
    "today": "Today",
    "registrationConfirmed": "Registration confirmed for {event}.",
    "eventDeletedOrRestricted": "Event is deleted or restricted",
    "eventDeleted": "Event has been deleted",
    "eventRestricted": "You don't have access to this event",
    "validations": {
      "titleValidation": "Title is required",
      "colorValidation": "Color is required",
      "startTimeValidation": "Start time is required",
      "endTimeValidation": "End time is required",
      "endTimeAfterStartTime": "End Time must be after Start Time",
      "startTimeMustBeInFuture": "Start time must be in future",
      "locationValidation": "Location is required",
      "locationValidationMobile": "Location is req",
      "locationUrlValidation": "Valid location URL is needed",
      "descriptionValidation": "Description is required",
      "descriptionValidationMaxLength": "Description cannot exceed 300 characters",
      "recaptchaError": "Verification failed! Please try again",
      "repeatIntervalValidation": "Occurrence is required",
      "repeatIntervalValidator": "Repeat Interval should be either day, week, month or year",
      "repeatIntervalRequired": "Repeat Interval is required",
      "repeatOccurrenceValidator": "Repeat Occurrence should be greater than 0",
      "repeatOccurrenceRequired": "Repeat Occurrence is required",
      "invalidDateFormat": "Invalid date format",
      "endDateMustBeAfterStartDate": "End date must be after the event start date",
      "recurringEndDateValidation": "Recurring End Date is required",
      "repeatsOnValidation": "Please select at least one day",
      "invalidDaySelection": "Invalid day selection",
      "endOptionRequired": "End option is required",
      "levelValidation": "Please select a level",
      "courseValidation": "Please select a course",
      "channelValidation": "Please select a channel",
      "eventPriceValidation": "Price is required and must be greater than {min}"
    },
    "placeholders": {
      "selectStartTime": "Select Start Time",
      "selectEndTime": "Select End Time",
      "selectLocation": "Select Location",
      "locationUrl": "Link/Address",
      "description": "Description",
      "selectRecurringEndDate": "Select Recurring End Date",
      "selectDate": "Select Date",
      "event": "Event",
      "selectColor": "Select a color",
      "selectAttendees": "Select Attendees",
      "selectPrivateChannel": "Select Private Channel",
      "selectCourse": "Select Course",
      "selectLevels": "Select Levels",
      "selectCalendar": "Select Calendar"
    },
    "labels": {
      "startTime": "Start Time",
      "endTime": "End Time",
      "others": "Others",
      "oneTimePriceForEventRegistration": "one time price for event registration.",
      "totalAmount": "Total Amount",
      "cardAuthorizationText": "By providing your card information, you allow {locationName} to charge card for future payments in accordance with their terms.",
      "secureAndSafePayments": "100% secure & safe payments",
      "day": "Day",
      "week": "Week",
      "month": "Month",
      "year": "Year",
      "recurringEvent": "Will the event be recurring event?",
      "repeatsEvery": "Repeats every",
      "repeatsOn": "Repeats on",
      "end": "End",
      "ends": "Ends",
      "neverEnds": "Never ends",
      "orange": "Orange",
      "red": "Red",
      "blue": "Blue",
      "green": "Green",
      "violet": "Violet",
      "purple": "Purple",
      "yellow": "Yellow",
      "title": "Title",
      "color": "Color",
      "allMembers": "All members",
      "membersAtALevel": "Members at a level",
      "membersOfACourse": "Members of a course",
      "membersOfAPrivateChannel": "Members of a private channel",
      "whoCanAttendTheEvent": "Who can attend the event?",
      "channel": "Channel",
      "course": "Course",
      "level": "Level",
      "remindAttendeesByEmail": "Remind attendees by email 1 day before",
      "hideLocationFromNonAttendees": "Hide location from non-attendees.",
      "addChargesToTheEvent": "Add charges to the event",
      "noPaymentRequired": "No payment required",
      "location": "Location",
      "link": "Link",
      "description": "Description",
      "timezone": "Timezone",
      "eventType": "Event Type",
      "eventTypeChangeWarning": "Changes to the event type or pricing will apply to all events in the series.",
      "never": "Never",
      "on": "On",
      "after": "After",
      "occurrences": "Occurrences",
      "selectEventEnd": "Select when the event will end.",
      "turnOnTestPayments": "Turn on test payments using a test card",
      "pay": "Pay",
      "hideAttendees": "Hide attendees from group members",
      "guests": "{count} guests",
      "guestList": "Guest List",
      "noAttendees": "No attendees yet",
      "viewAttendees": "View Attendees",
      "exportAttendees": "Export Attendees"
    },
    "notifications": {
      "eventCreated": "Event successfully created!",
      "pickImageFailed": "Failed to pick image",
      "pickImageFailedContent": "An error occurred while selecting the image.",
      "eventUpdated": "Event successfully updated!",
      "eventCreationFailed": "Event creation failed!",
      "eventUpdateFailed": "Event update failed!",
      "EVENT_CREATE_INVALID_TIME_RANGE": "Start time must be before end time.",
      "EVENT_CREATE_PAST_TIME_NOT_ALLOWED": "Start time must be in the future.",
      "EVENT_CREATE_DURATION_EXCEEDED": "Event duration exceeds the maximum allowed limit.",
      "EVENT_CREATE_FAILED": "Unable to create event. Please try again.",
      "EVENT_UPDATE_NOT_FOUND": "Unable to update event because it could not be found.",
      "EVENT_UPDATE_UNAUTHORIZED": "You do not have permission to update this event.",
      "EVENT_UPDATE_INVALID_OPERATION": "This event update action is not allowed.",
      "eventDeleted": "Event successfully deleted!",
      "eventDeletionFailed": "Event deletion failed!",
      "paymentFailed": "Payment failed!",
      "registrationSuccessful": "Registration successful!",
      "registrationFailed": "Registration failed!",
      "addToCalendarFailed": "Failed to add event to calendar!",
      "locationDetailsCopied": "Location details copied to clipboard!",
      "registrationDeclined": "Registration declined successful!",
      "registrationDeclinedFailed": "Registration decline failed!",
      "fetchAttendeesFailed": "Failed to load attendees",
      "emailCopied": "Email copied to clipboard",
      "exportAttendeesFailed": "Failed to export attendees"
    },
    "selectCalendar": "Select Calendar",
    "eventImage": "Event image",
    "errorLoadingEvent": "Error loading event"
  },
  "login": {
    "invite": "invited you to join"
  },
  "contentReports": {
    "contentDeleted": "Content has been deleted!",
    "noActionTaken": "No action taken on the reported content!",
    "reportedContentNotFound": "Reported content not found, Might be acted upon already.",
    "reported": "Reported",
    "viewAllReportedContentHere": "You can view all the reported content here",
    "takeActionOnReportedContent": "Take action on the reported content",
    "andOthers": "and {count} others",
    "reportedThisPost": "reported this post",
    "keep": "KEEP",
    "remove": "REMOVE",
    "deleteContent": "Delete Content",
    "deleteConfirmation": "Are you sure you want to delete this content?",
    "noMemberReportedContent": "No member-reported content",
    "whenMembersReportPostsOrComments": "When members report posts or comments, they will appear here for you to review. You can keep or delete them, as well as suspend, remove or block the members who posted them.",
    "reportedThisComment": "You have reported this comment"
  },
  "contentUnavailable": {
    "thisContentIsntAvailable": "This content isn't available at the moment",
    "whenThisHappens": "When this happens, it's usually because the owner only shared it with a small group of people or changed who can see it or it's been deleted"
  },
  "search": {
    "noResultsFor": "0 results for \"{query}\" in community",
    "noResultsFound": "No results found"
  },
  "noCommunities": {
    "noCommunitiesFound": "No Communities Found",
    "startCreatingYourOwnCommunities": "Start creating your own communities and engage with your audience!",
    "noCommunitiesFoundGokollab": {
      "notJoinedA": "Not Joined a",
      "communities": "Communities",
      "yet": "Yet"
    },
    "noCommunitiesFoundGokollabDescription": "Discover spaces where people share ideas, support each other, and grow together."
  },
  "noCourses": {
    "noCoursesFoundGokollab": {
      "notEnrolledInA": "Not Enrolled in a",
      "course": "Course",
      "yet": "Yet"
    },
    "noCoursesFoundGokollabDescription": "Explore high-impact courses designed to help you learn, improve, and succeed."
  },
  "notFound": {
    "ohNo": "oh no...",
    "weHaveHadAnError": "We have had an error",
    "error404": "Error 404",
    "sorryPleaseCheckBack": "Sorry...please check back in just a moment."
  },
  "time": {
    "justNow": "Just now",
    "timeAgo": "{value}{unit} ago",
    "timeAgoFull": "{value} {unit} ago",
    "units": {
      "year": "y",
      "years": "years",
      "month": "mo",
      "months": "months",
      "week": "w",
      "weeks": "weeks",
      "day": "d",
      "days": "days",
      "hour": "h",
      "hours": "hours",
      "minute": "m",
      "minutes": "minutes",
      "second": "s",
      "seconds": "seconds",
      "monthly": "Monthly",
      "weekly": "Weekly",
      "annually": "Annually"
    },
    "dayAbbreviations": {
      "mon": "Mon",
      "tue": "Tue",
      "wed": "Wed",
      "thu": "Thu",
      "fri": "Fri",
      "sat": "Sat",
      "sun": "Sun"
    }
  },
  "emojiPicker": {
    "notfound": "No Emoji Found",
    "recent": "Frequently Used",
    "smileys": "Smileys & Emoticon",
    "people": "People & Body",
    "nature": "Animals & Nature",
    "foods": "Food & Drink",
    "activity": "Activity",
    "places": "Travel & Places",
    "objects": "Objects",
    "symbols": "Symbols",
    "flags": "Flags",
    "custom": "Custom"
  },
  "topNavBarHeaderText": {
    "discussion": "Discussion",
    "learning": "Learning",
    "people": "People"
  },
  "globalUserProfile": {
    "ownedBy": "Owned by {name}",
    "memberships": "Memberships",
    "membershipsInCommon": "Memberships ({count} in common)",
    "membersCount": "{count} members",
    "contributions": "{count} contributions to {group}",
    "contributionsFor": "Contributions for",
    "justPosts": "Just posts",
    "postAndComments": "Post and comments",
    "followSuccess": "You’ve started following",
    "unfollowSuccess": "You’re no longer following"
  },
  "profile": {
    "active": "Active",
    "ago": "ago",
    "bio": "Bio"
  },
  "golive": {
    "golive": "Live Room",
    "defaultEventTitle": "Community Live Event",
    "meetingCreationFailed": "Failed to create GoLive meeting. Please try again.",
    "selectVideoSourceToStart": "Select a video source to start streaming",
    "chooseHowToGoLive": "Choose how you want to go live",
    "flipCamera": "Flip Camera",
    "participants": "Participants",
    "chats": "Chats",
    "react": "React",
    "raise": "Raise",
    "shareScreen": "Share",
    "letsCheckYourCamAndMic": "Let's check your cam and mic",
    "hostedBy": "Hosted By",
    "join": "Join",
    "needCameraPermission": "Need Camera Permission",
    "needMicrophonePermission": "Need Microphone Permission",
    "needSpeakerPermission": "Need Speaker Permission",
    "createLiveVideo": "Create a live Video",
    "host": "Host",
    "chooseWhereToPost": "Choose where to post",
    "whenAreYouGoingLive": "When are you going live?",
    "postingIn": "posting in",
    "live": "Live",
    "postDetails": "Post Details",
    "streamingSoftware": "Streaming Software",
    "streamingSoftwareDescription": "You can use a streaming software like Zoom, OBS, or StreamYard to broadcast directly. Simply copy the provided Stream URL and Stream Key into your streaming software’s settings. Once configured, start your broadcast in the software, and it will stream live to your selected platform automatically.",
    "streamKey": "Stream Key",
    "streamKeyDescription": "This can be re-used every time you go live. You can only broadcast one live video at a time with your persistent stream key.",
    "serverUrl": "Server URL",
    "serverUrlDescription": "This maybe referred to as \"URL\" or \"Address\" in your streaming software.",
    "selectVideoSource": "Select Video Source",
    "copyPasteStreamKey": "Copy and paste the stream key into your streaming software.",
    "copyPasteServerUrl": "Copy and paste the server URL into your streaming software.",
    "addPostDetails": "Add Post Details",
    "enterTitle": "Enter Title",
    "notifyMembers": "Notify members you're going live (sends only in-app and push notifications)",
    "notifyMembersMobile": "Notify members you're going live",
    "meetingRoom": "Meeting Room",
    "meetingRoomDescription": "Use the Meeting Rooms feature to host live sessions where all participants can turn on their webcams, unmute, and interact in real-time. This creates a virtual room experience similar to Zoom or Google Meet, allowing everyone to see and talk to each other face-to-face.",
    "cameraControls": "Camera Controls",
    "cameraControlsTooltip": "Configure your camera and audio settings before going live. Make sure your camera and microphone are properly connected and have the necessary permissions.",
    "selectMediaSource": "Select a media source",
    "startScreenShare": "Start screen share",
    "stopScreenShare": "Stop screen share",
    "wasLive": "was live",
    "isLive": "is live",
    "goingLive": "is going live",
    "tapToAddDescription": "Tap to add a description...",
    "selectChannel": "Select Channel",
    "saveAsPost": "Keep live stream as post",
    "selectVideoSourceTooltip": "You can choose between Streaming Software or Webcam when going live:\n\n1. Streaming Software\n   • We will provide you with a Stream Key and Stream URL.\n   • You need to configure these in Zoom, OBS, or any third-party software that supports live streaming.\n\n2. Webcam\n   • Go live directly using your camera and microphone.\n   • Participants can view the live stream and interact through the live chat.\n   • As the host, you can control and revoke access to the camera or microphone at any time.",
    "pleaseSelectCameraMicrophoneSpeaker": "Please select camera, microphone and speaker",
    "pleaseStartStreamBeforeGoingLive": "Please start the stream before going live",
    "watching": "Watching",
    "processingRecording": "Processing Recording",
    "recordingFailed": "Recording unavailable",
    "recordingFailedDescription": "We ran into an issue while processing this live session, and the recording couldn’t be saved",
    "streamEndedRecordingWillBeAvailableSoon": "Stream ended. The recording is being processed and will be available shortly.",
    "joinStream": "Join Stream",
    "recordingInProgress": "Recording in progress",
    "recordingNotAvailable": "Recording failed",
    "leaveSession": "Leave Session",
    "endSession": "End Session",
    "rec": "REC",
    "selectCamera": "Select Camera",
    "noCamerasFound": "No cameras found",
    "cameraPermissionNeeded": "Camera permission needed",
    "leave": "Leave",
    "chooseMicCam": "Choose Mic/Cam",
    "selectMicrophone": "Select Microphone",
    "selectSpeaker": "Select Speaker",
    "noMicrophonesFound": "No microphones found",
    "noSpeakersFound": "No speakers found",
    "microphonePermissionNeeded": "Microphone permission needed",
    "speakerPermissionNeeded": "Speaker permission needed",
    "noParticipantOpenCamOrMic": "This meeting wasn’t recorded as no participants enabled their mic or camera. Recordings are only created when at least one participant interacts."
  }
}
